import { Switch } from '@mui/material'

import StatusBadge from './StatusBadge'
import { MovieT } from '../type'
import { BsChevronRight } from 'react-icons/bs'
import AddSeasonButton from './AddSeasonButton'
import { useNavigate } from 'react-router-dom'

const Seasons = ({ movie }: { movie: MovieT }) => {
    const navigate = useNavigate()
    return (
        <div className='flex flex-col gap-8 '>
            {movie?.seasons?.length ?
                movie?.seasons?.map(season => (<div className="rounded-lg p-6 flex gap-10 items-center border w-full">
                    <img src={season?.poster} className='w-1/12 border h-5/6 rounded-md' alt='season' />
                    <div className='w-full flex flex-col gap-4'>
                        <div className='w-full'>
                            <div className='flex justify-between'>
                                <div className='flex gap-4 text-xl font-extrabold items-center'> <p className='text-black'>Season {season?.number}</p> <StatusBadge status={season?.status?.toLowerCase()} /></div>
                                <div className=' flex gap-4'>
                                    <div className='rounded-md px-2 flex items-center border'>
                                        Live <Switch checked={season?.status === 'Live'} />
                                    </div>
                                    <div onClick={() => navigate(`/movie-box/${movie?.id}/season/${season?.id}`)} className='rounded-md px-2 flex items-center border cursor-pointer gap-3'>
                                        View details <BsChevronRight />
                                    </div>
                                </div>

                            </div>
                            <p>{movie?.description}</p>
                        </div>
                        <div className='border w-full border-dashed' />
                        <div className='gap-28 flex'>
                            <div className='flex flex-col'>
                                <p className='text-gray-400 text-sm'>Episodes</p>
                                <p className='text-base'>{season?.episode_count}</p>
                            </div>
                            <div className='flex flex-col'>
                                <p className='text-gray-400 text-sm'>Status</p>
                                <p className='text-base'>{season?.status}</p>
                            </div>
                            <div className='flex flex-col'>
                                <p className='text-gray-400 text-sm'>Release year</p>
                                <p className='text-base'>{season?.release_year}</p>
                            </div>
                        </div>
                    </div>
                </div>))
                :
             <AddSeasonButton onClick={() => navigate(`/movie-box/add-movie?media_type=series`)} />
            }
        </div>
    )
}

export default Seasons